import { createAsyncThunk } from '@reduxjs/toolkit'

import type { RootState } from 'redux/store/RootReducer'
import type { AppDispatch } from 'redux/store'
import { fetchSignUpFormQuestions } from 'api/SignUpFormQuestion/Action'

export const fetchParticipantProfileSignupFormQuestions: any = createAsyncThunk<
  any,
  any,
  {
    dispatch: AppDispatch
    state: RootState
  }
>(
  'participantProfile/fetchSignupFormQuestions',
  async (_obj, { rejectWithValue }) => {
    try {
      const response = await fetchSignUpFormQuestions()
      return response
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)
